const programAssets = {
  "Information Technology": {
    image: "/images/courses/Information Technology.png",
    color: "#1E63C6",
    intake: "January, June & August",
    modules: "12 Modules",
    heroSummary: "Software, networking & systems engineering",
    skills: ["Web Development", "Networking", "Cybersecurity", "Database Management"],
    careers: ["Software Developer", "Network Engineer", "IT Support Specialist", "Systems Analyst"],
    requirements: ["Matric with Mathematics", "Basic computer literacy", "Motivation letter"],
  },
  "Film Studies": {
    image: "/images/courses/Film Studies.png",
    color: "#E53935",
    intake: "January, June & August",
    modules: "8 Modules",
    heroSummary: "Cinematography, editing & storytelling",
    skills: ["Cinematography", "Video Editing", "Scriptwriting", "Post-Production"],
    careers: ["Film Director", "Video Editor", "Cinematographer", "Content Creator"],
    requirements: ["Matric (any stream)", "Portfolio or short motivation", "Willingness to collaborate on shoots"],
  },
  "Graphic Design": {
    image: "/images/courses/Graphic Design.png",
    color: "#4A90E2",
    intake: "January, June & August",
    modules: "10 Modules",
    heroSummary: "Visual identity, branding & digital art",
    skills: ["Brand Identity", "Typography", "UI/UX Design", "Digital Illustration"],
    careers: ["Graphic Designer", "Brand Strategist", "UI/UX Designer", "Art Director"],
    requirements: ["Matric (any stream)", "Basic drawing or digital interest", "Portfolio is a plus, not required"],
  },
};

function sentenceSummary(text = "") {
  const trimmed = String(text).trim();
  if (!trimmed) return "";
  const firstSentence = trimmed.split(/[.!?](?:\s|$)/)[0]?.trim();
  return firstSentence ? `${firstSentence}.` : trimmed;
}

export function buildProgramCards(programs = []) {
  return programs.map((program) => {
    const asset = programAssets[program.name] || {};
    return {
      ...program,
      image: asset.image || "/images/courses/Information Technology.png",
      color: asset.color || "#1E63C6",
      intake: asset.intake || "January, June & August",
      modules: asset.modules || "Program Modules",
      heroSummary: asset.heroSummary || sentenceSummary(program.description),
      skills: asset.skills || [],
      careers: asset.careers || [],
      requirements: asset.requirements || [],
      description: program.description || "",
      duration: program.duration || "3 Years",
    };
  });
}
